export const FACET_NAME_TO_QUERY_PARAM = {
  bisacCode: "_cat",
  contentCreatorName: "_c",
  contentSource: "_cs",
  contentDatePublished: "_pd",
  contentLanguage: "_l",
  contentLicenseType: "_lt",
  contentPlaceOfPublication: "_pop",
  contentProjectNameFacet: "_pn",
  contentPublisherName: "_p",
  contentSubProjectNameFacet: "_spn",
  contentType: "_f",
  modules: "_mod",
  parentAnthologies: "_pa",
  type: "_type",
};

export const FACET_NAME_TO_DISPLAY_NAME = {
  bisacCode: "Categories",
  contentCreatorName: "Contributors",
  contentDatePublished: "Publication Years",
  contentLanguage: "Languages",
  contentLicenseType: "License Types",
  contentPlaceOfPublication: "Places of Publication",
  contentProjectNameFacet: "Project Name",
  contentPublisherName: "Publishers",
  contentSubProjectNameFacet: "SubProject Name",
  contentSource: "Content Sources",
  contentType: "Content Types",
  modules: "Modules",
  parentAnthologies: "Parent Anthologies",
  type: "Media Types",
};

export const FACET_NAME_DISPLAY_CODE = {
  parentAnthologies: true,
};

export const PUBLICATION_YEAR_GROUPS = [
  {
    name: "Before 1000",
    end: 1000,
    expression: "|0999-12-31T23:59:59Z",
  },
  {
    name: "1000 - 1499",
    start: 1000,
    end: 1500,
    expression: "1000-01-01T00:00:00Z|1499-12-31T23:59:59Z",
  },
  {
    name: "1500s",
    start: 1500,
    end: 1600,
    expression: "1500-01-01T00:00:00Z|1599-12-31T23:59:59Z",
  },
  {
    name: "1600s",
    start: 1600,
    end: 1700,
    expression: "1600-01-01T00:00:00Z|1699-12-31T23:59:59Z",
  },
  {
    name: "1700s",
    start: 1700,
    end: 1800,
    expression: "1700-01-01T00:00:00Z|1799-12-31T23:59:59Z",
  },
  {
    name: "1800s",
    start: 1800,
    end: 1900,
    expression: "1800-01-01T00:00:00Z|1899-12-31T23:59:59Z",
  },
  {
    name: "1900s",
    start: 1900,
    end: 1910,
    expression: "1900-01-01T00:00:00Z|1909-12-31T23:59:59Z",
  },
  {
    name: "1910s",
    start: 1910,
    end: 1920,
    expression: "1910-01-01T00:00:00Z|1919-12-31T23:59:59Z",
  },
  {
    name: "1920s",
    start: 1920,
    end: 1930,
    expression: "1920-01-01T00:00:00Z|1929-12-31T23:59:59Z",
  },
  {
    name: "1930s",
    start: 1930,
    end: 1940,
    expression: "1930-01-01T00:00:00Z|1939-12-31T23:59:59Z",
  },
  {
    name: "1940s",
    start: 1940,
    end: 1950,
    expression: "1940-01-01T00:00:00Z|1949-12-31T23:59:59Z",
  },
  {
    name: "1950s",
    start: 1950,
    end: 1960,
    expression: "1950-01-01T00:00:00Z|1959-12-31T23:59:59Z",
  },
  {
    name: "1960s",
    start: 1960,
    end: 1970,
    expression: "1960-01-01T00:00:00Z|1969-12-31T23:59:59Z",
  },
  {
    name: "1970s",
    start: 1970,
    end: 1980,
    expression: "1970-01-01T00:00:00Z|1979-12-31T23:59:59Z",
  },
  {
    name: "1980s",
    start: 1980,
    end: 1990,
    expression: "1980-01-01T00:00:00Z|1989-12-31T23:59:59Z",
  },
  {
    name: "1990s",
    start: 1990,
    end: 2000,
    expression: "1990-01-01T00:00:00Z|1999-12-31T23:59:59Z",
  },
  {
    name: "Recent",
    start: 2000,
    expression: "2000-01-01T00:00:00Z|",
  },
];
